module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-4.svg";